<div class="container fade h-full w-full">
    <div class="">
        <div class="border-b border-b-gray-300 zuper-dialog-header">
            <div class="flex justify-between">
                <h6 mat-dialog-title class="font-semibold primary-font">{{data?.data?.title | translate}}</h6>
            </div>
            <div class="flex items-center ml-auto">
                <span mat-dialog-close
                    class="rounded-full flex justify-center items-center hover:bg-gray-200 h-9 w-9 p-2 cursor-pointer">
                    <em class="ti ti-x text-xl font-bold"></em>
                </span>
            </div>
        </div>
    </div>
    <div class="bg-white py-6 px-4">
        <div class="w-full">
            <input 
            type="text" 
            name="header" 
            [formControl]="header"
            id="header" 
            class="block w-full rounded-md border border-gray-300 focus:border-indigo-500 bg-white px-3 py-3 leading-none text-base"
            placeholder="{{ 'placeholder.line_item.header' | translate}}"
            >     
            <p class="text-red-500 text-base mt-1" *ngIf="getError()">{{getError() | translate}}</p>       
        </div>
    </div>
    <div class="flex justify-end border-t border-gray-300 zuper-dialog-footer">
        <div class="flex justify-end space-x-3">
        <button mat-stroked-button mat-dialog-close class="px-6 items-center py-2 border b-1 border-gray-300 btn-small shadow-sm text-base font-medium hover:bg-gray-100 rounded-md focus:outline-none">{{'close.text' | translate}}</button>
        <button type="button" (click)="submitForm()" class="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary focus:outline-none">{{data?.data?.submit | translate}}</button>
        </div>
    </div>
  </div>